export default "__VITE_ASSET__CWBgbe1O__"